<template>
  <section v-if="totalPages > 1">
    <div class="flex mt-8 justify-center">
      <button
        type="button"
        @click="pageChange(currentPage - 1)"
        :disabled="currentPage <= 1"
        :class="{ 'text-gray-light': currentPage <= 1 }"
        class="px-2 py-1 focus:outline-none"
      >
        Prev
      </button>

      <div v-for="number in pageNumbersToShow" :key="number">
        <button
          type="button"
          v-if="number !== '...'"
          class="h-8 w-8 rounded-full focus:outline-none"
          :class="{ 'bg-green-light text-white': currentPage == number }"
          @click="pageChange(number)"
        >
          {{ number }}
        </button>
        <span v-else class="h-8 w-8 rounded-full">{{ number }}</span>
      </div>
      <button
        type="button"
        @click="pageChange(currentPage + 1)"
        :disabled="currentPage >= totalPages"
        class="px-2 py-1 focus:outline-none"
        :class="{ 'text-gray-light': currentPage >= totalPages }"
      >
        Next
      </button>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    handlePageChange: Function,
    currentPage: Number,
    totalPages: Number,
  },
  data() {
    return {
      threashold: 6,
      pageNumbersToShow: [],
    };
  },
  methods: {
    pageChange(currentPage) {
      this.handlePageChange(currentPage);
    },
    setPageNumbersToShow() {
      const arr = [];
      let prev = true;
      let after = true;
      if (this.totalPages > this.threashold) {
        const valuesArray = [
          1,
          2,
          this.currentPage - 1,
          this.currentPage,
          this.currentPage + 1,
          this.totalPages - 1,
          this.totalPages,
        ];
        for (let i = 1; i <= this.totalPages; i++) {
          if (valuesArray.includes(i)) {
            arr.push(i);
          } else {
            if (i < this.currentPage && prev) {
              arr.push("...");
              prev = false;
            } else if (i > this.currentPage && after) {
              arr.push("...");
              after = false;
            }
          }
        }
      } else {
        for (let i = 1; i <= this.totalPages; i++) {
          arr.push(i);
        }
      }
      this.pageNumbersToShow = arr;
    },
  },
  watch: {
    currentPage: function () {
      this.setPageNumbersToShow();
    },
    totalPages () {
      this.setPageNumbersToShow();
    }
  },
  created() {
    this.setPageNumbersToShow();
  },
};
</script>